module.exports = __webpack_public_path__ + "static/img/wilfred.a6a426b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wilfred.png
// module id = 60Nf
// module chunks = 0